import Route from "@/scripts/routeRegistrar"
const RouteRegistrar = new Route('management');

RouteRegistrar.add("management/users/Users", "users", "users", "مدیریت کاربران")
RouteRegistrar.add("management/roles/Roles", "roles", "roles", "نقش ها")
RouteRegistrar.add("management/profile/Index", "profile", "profile", "پروفایل")
RouteRegistrar.add("management/owners/Index", "owners", "owners", "مدیریت صاحب بار")
RouteRegistrar.add("management/carriers/Index", "carriers", "carriers", "مدیریت باربری")
RouteRegistrar.add("management/drivers/Index", "drivers", "drivers", "مدیریت رانندگان")
RouteRegistrar.add("management/contacts/Index", "contacts", "contacts", "مدیریت تماس با ما")
RouteRegistrar.add("management/slides/Index", "slides", "slides", "مدیریت اسلاید ها")
RouteRegistrar.add("management/appIcons/Index", "app-icons", "app-icons", "آیکن ها");
RouteRegistrar.add("management/socialMedia/Index", "social-media", "social-media", "شبکه های اجتماعی");
RouteRegistrar.add("management/settings/Settings", "settings", "settings", "تنظیمات");
RouteRegistrar.add("management/tickets/Index", "tickets", "tickets", "مدیریت تیکتینگ");

const routes = RouteRegistrar.allRoutes()


export default routes;
